import {type IAsset} from '@netx/core-asset-next/schema';
import {assetIsInCart} from './utils';

export const canAddAssetToCart = (asset?: IAsset) => !assetIsInCart(asset);

export const canRemoveAssetFromCart = (asset?: IAsset) => assetIsInCart(asset);
